import React, { Component, Fragment } from 'react';
import { Route, NavLink, Switch, Redirect } from 'react-router-dom';
import { translate } from 'react-i18next';
import { request } from './../../../../config';
import Transfers from './Transfers';
import Exchanges from './Exchanges';
class History extends Component {

    render() {
        let { alertState, t, logout, updateAppState } = this.props;
        return (
            <Fragment>
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('history')}</h2>
                    </div>
                </div>
                <div className="dashboard-container-main-section-vertical">
                    <div className="dashboard-transfer-search-list-section" style={{marginTop: '0'}}>
                        <div style={{ width: '100%', marginBottom: '22px' }}>
                            <div className="dashboard-transfer-list-header">
                                <div className="dashboard-transfer-list-header-container dashboard-transfer-list-header-container__left">
                                    <NavLink exact to="/dashboard/transfer/history/transfers" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("transfers")}</NavLink>
                                    <NavLink exact to="/dashboard/transfer/history/exchange" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("Conversion")}</NavLink>
                                </div>
                            </div>
                        </div>
                        <Switch>
                        <Redirect exact from="/dashboard/transfer/history" to="/dashboard/transfer/history/transfers" />
                            <Route path="/dashboard/transfer/history/transfers" render={(routeProps) => <Transfers  {...routeProps} logout={() => logout()}  updateAppState={updateAppState} alertState={alertState}  />} />     
                            <Route path="/dashboard/transfer/history/exchange" render={(routeProps) => <Exchanges  {...routeProps} logout={() => logout()} updateAppState={updateAppState} alertState={alertState}  />} />     
                        </Switch>
                    </div>
                </div>
            </Fragment >
        )
    }
}
export default translate("translation")(History);